import { Component, OnInit } from '@angular/core';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { MenuService } from '../../shared/layout/menu-service/menu.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { TripService } from 'src/app/services/core/trip/trip.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import * as moment from 'moment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { TitleCasePipe } from '@angular/common';
@UntilDestroy()
@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.css']
})
export class MarketplaceComponent implements OnInit {
   user: any;
    subMenus:any;
    selectedStatus: any;
    todayDate: any;
    search:any;
  selectedDropdownIndex: any;
  toggleActionButtons = false;
    selectedTrips:any = [];
    selectedSingleTrip:any = null;
    tripId:any;
    companies:any;
    levelofservices:any;
    isDistributionModal = false;
    preServiceAreas:any;
    preLevelOfService: any = {};
    trips:any = [];
  
    spacetypes:any;
    preSpacetypes:any = {};
    // preMembers:any = {};
    preAppointmentType:any = {};
  
    // Pagination
    currentPage = 1;
    totalResults = 0;
    totalPages = 0;
    serviceAreas:any
    numberOfRecords = NUMBER_OF_RECORDS
    memberNotesObj:any;

    thresholds: any;
    selectedEntity:any;
    previousAssignedCompanies: any
    threshold: any;
    thresholdsSpaceTypes: any;
    thresholdDashboard: any;
    tripsMilesBySaceType: any
    companyDetail:any;
    fareEstimation:any;
    fareCalculation = {
    fundingSourceFare: 0,
    companyFare: 0,
    commission: 0,
  }
  tripsUniqueSpaceTypes: any;
  totalMiles: any;
  totalTripsCount: any;
  selectedTrip: any;
  

  constructor(
      private appointmentService : AppointmentTypeService,
      private memberService : MemberService,
      private SpaceTypeService : SpaceTypeService,
      private credentialService: CredentialService,
      private LosService: LosService,
      private tripService : TripService,
      private sharedDataService: SharedDataService,
      private serviceAreasService: ServiceAreasService
    ) { }
  ngOnInit(): void {
    this.todayDate = [
         moment().startOf('day').toISOString(),
         moment().endOf('day').toISOString()
       ];
    this.getAppointmentTypes();
    // this.getAllMembers();
    this.getSpaceType();
    this.getUser();
    this.getTrips(this.currentPage)
  }

   getUser() {
      this.sharedDataService
      .getUser().pipe(untilDestroyed(this))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getTrips(this.currentPage);
        }
      });
      this.getServiceAreas();
      this.getLevelOfService()
    }
    
    getAppointmentTypes(){
      const queryparams = {
        isActive: true, 
        limit:9999
      }
      this.appointmentService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) =>{
        if(data.results ){
          this.preAppointmentType = data.results.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
        }
      })
    }
  
    getSpaceType() {
      const queryParams = {
        isActive: true, 
        limit:9999
      }
      this.SpaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.spacetypes = data.results;
          this.preSpacetypes = this.spacetypes.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
        }
      })
    }
  
    // getAllMembers(){
    //   let queryParams = {
    //     limit : 9999,
    //   }
    //   this.memberService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
    //     if (data && data.results ){
    //       this.preMembers =  data.results.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
    //     }
    //   })
    // }
  
    getTrips(page:any) {
      const queryparams = {
        limit: 50,
        page,
        isFareEstimation: true,
        status: 'marketplace',
        time: [this.todayDate[0], this.todayDate[1]],
      }
      this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this)).subscribe((data:any) => {
        if (data && data.results) {
         this.trips = data.results;
         this.totalPages = data.totalPages;
         this.totalResults = data.totalResults;
         this.tripsUniqueSpaceTypes = _.uniq(this.trips.map((item: any) => item.spaceType));
        }
      })
    }
  
    
    // onPageChange(page: number) {
    //   this.currentPage = page;
    //   this.getTrips(page);
    // }
  
    openDetailModal(trip:any){
      this.tripId = trip.id;
    }
  
    getServiceAreas() {
      this.serviceAreasService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data && data.results ) {
            this.serviceAreas = data.results;
            this.preServiceAreas = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
          }
        })
    }
  

  
     getLevelOfService(){
       this.LosService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data && data.results ) {
            this.levelofservices = data.results;
            this.preLevelOfService = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
          }
        })
    }

    closeModal(){
      this.isDistributionModal = false;
    }
  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    console.log("evt", evt)
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  acceptTrips(event: any) {
    this.selectedSingleTrip = event;
    const payload = {
      selectedIds: [event.id],
      company: this.user && this.user.company? this.user.company.id : null,
      status: "offered"
    };
    this.apiRequest(payload);
  }

  apiRequest_Unused(payload: any) {
    this.tripService.sendtoMarketPlace(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const index = this.trips.findIndex((trip: any) => trip.id === this.selectedSingleTrip.id);
        this.trips.splice(index, 1);
        this.selectedSingleTrip = null;
      }
    })
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  getMarketplaceTrip(trip: any) {
    this.selectedTrip = trip;
    this.assign();
    // this.getThresholdAndFare();
  }

 async reserveTrip([tripID, isReserve]: [any, boolean]) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to ${isReserve? "reserve": "unreserve"} this trip`,
      "warning",
      `${isReserve?'Reserve':'Un Reserve'}`,
      "Cancel"
    );
    if (!result.value) return;

    this.tripService.reserveTrip(tripID,isReserve).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.getTrips(1)
      }
    })
  }

  async assign() {
    if (this.isViolationExist()) {
      sweetAlert('Alert', 'A service area violation exists. Do you want to proceed?', 'warning', 'OK', 'Cancel')
        .then((result) => {
          console.log('result', result);
          if (result.isConfirmed) {
            this.distribute();
          }
        });
    } else {
      this.distribute();
    }
  }

  async isAnyThresholdExceed() {
    let blnReturn = true;
    const exceededSpaceTypes = this.thresholds.filter((threshold: any) =>
      threshold.consumedMiles?.isExceeded ||
      threshold.consumedTrips?.isExceeded ||
      threshold.consumedAmount?.isExceeded
    ).map((threshold: any) => threshold.spaceType.title);
    if (exceededSpaceTypes && exceededSpaceTypes.length) {
      const result = await sweetAlert('Alert', `Threshold exceeded of Space Types: ${exceededSpaceTypes.toString()}. Do you wish to continue?`, 'warning', 'Yes', 'No');
      if (!result.value) blnReturn = false;
    }
    return blnReturn;
  }

  isViolationExist() {
    const company = this.user?.company;
    const companyServiceAreas = company ? company.serviceAreas : null;

    if (!(companyServiceAreas && companyServiceAreas.length)) {
      return false;
    }

    const tripsServiceAreas = Array.from(
      new Set(this.trips.map((trip: any) => trip.serviceArea))
    );

    return !companyServiceAreas.includes(this.selectedTrip.serviceArea);
  }

  async distribute() {
    const result = await sweetAlert(
      "Alert",
      "Are you sure you want to get this trip",
      "warning",
      "Yes",
      "No"
    );
    if (!result.value) return;

    const payload: any = {
      pre: [],
      selectedIds: [this.selectedTrip.id],
      status: "offered"
    };

    payload.company = this.user?.company?.id;

    this.apiRequest(payload);
  }

  apiRequest(payload: any) {
    this.tripService.acceptMarketplaceTrip(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res:any) => {
        if (res) {
          const {statusUpdate} = res;
          const {skippedTrips} = statusUpdate;
         if (skippedTrips && skippedTrips.length) {
              const html = this.getSkippedTripsHtml(skippedTrips);
              sweetAlertWithHtml("Alert", " ", "alert", "OK", html);
              return
            }
          const idx = this.trips.findIndex((trip: any) => trip.id === this.selectedTrip.id);
          this.trips.splice(idx, 1);

          if (res.statusUpdate) {
            sweetAlert("Alert", 'Trip has successfully been picked up from marketplace', "alert", "OK");
          }
        }
      },
      error: (err: any) => {
        if(err){
           sweetAlert(
            'Alert',
            err,
            'alert',
            'OK'
          );
        }
      }
 });
}

  getSkippedTripsHtml(skippedTripsIds: any) {
      const skippedTrips = this.trips.filter((trip: any) => skippedTripsIds.includes(trip.id))
      const message = "This trip could not be updated due to fare/threshold issues.(<b>Please contact your broker</b>)";
      let html = `<p class="mb-4">${message}</p><div
      class="max-h-[400px] overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
      <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
        <div class="flow-root h-full overflow-y-auto">
          <div class="-my-2">
            <div class="inline-block min-w-full py-2 align-middle">
              <table class="min-w-full border-separate border-spacing-0">
                <thead>
                  <tr>
                     <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Member
                    </th>
                    <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Reference ID
                    </th>
                  </tr>
                </thead>
                <tbody>`;
      skippedTrips.forEach((trip: any) => {
        html += `
                  <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                    <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     ${trip?.member?.displayName ? new TitleCasePipe().transform(trip?.member?.displayName) : ''}}
                    </td>
                    <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     ${trip.reference}${trip.suffix ? '-'+trip.suffix : ''}
                    </td>
                  </tr>
                  `;
      });
      html += `
                </tbody>
              </table>
              </div>
              </div>
              </div>
              </div>
              </div>
              `
      return html;
    }

  getFareEstimation(){
    const payload = {
      trips : [this.selectedTrip.id],
      company: this.user?.company?.id
    };

    // return this.credentialService.getFareEstimation(payload);
  }

  getCompanyThreshold() {
    const queryParams = {
      isActive: true,
      time: this.trips[0].pickup.time,
      spaceType: this.selectedTrip.spaceType
    }

    const payload = {
      company: this.user?.company?.id
    }
    // return this.credentialService.getCompanyThreshold(payload,queryParams);
  }

  getThresholdAndFare() {
    // forkJoin({
    //   // fareEstimation: this.getFareEstimation(),
    //   threshold: this.getCompanyThreshold()
    // }).pipe(untilDestroyed(this))
    //   .subscribe(({ threshold }: any) => {
    //     if (threshold) {
    //       this.threshold = threshold;
    //       this.calculateNewThreshold();
    //     }

    //     this.assign();
    //   });
  }

  calculateNewThreshold() {
    const { thresholds, thresholdDashboard } = this.threshold;
    this.thresholdsSpaceTypes = thresholds.map((threshold: any) => threshold.spaceType._id);
    this.groupTripsBySpaceType(this.thresholdsSpaceTypes);
    this.thresholdDashboard = thresholdDashboard.reduce((acc: any, item: any) => {
      const spaceTypeId = item.spaceType._id;
      acc[spaceTypeId] = item;
      return acc;
    }, {});

    thresholds.forEach((threshold: any) => {
      const spaceTypeId = threshold.spaceType._id;
      const dashboard = this.thresholdDashboard[spaceTypeId];
      const newTotals = this.tripsMilesBySaceType[spaceTypeId];

      const consumedMiles: any = {
        now: dashboard?.consumedMiles || 0,
        percentage: ((dashboard?.consumedMiles || 0) / threshold.miles) * 100
      }
      const consumedTrips: any = {
        now: dashboard?.consumedTrips || 0,
        percentage: ((dashboard?.consumedTrips || 0) / threshold.trips) * 100
      };
      const consumedAmount: any = {
        now: dashboard?.consumedAmount || 0,
        percentage: ((dashboard?.consumedAmount || 0) / threshold.amount) * 100
      };

      if (newTotals) {
        // Miles
        consumedMiles['new'] = newTotals.totalMiles;
        consumedMiles['isExceeded'] = (consumedMiles.now + consumedMiles.new) > threshold.miles;
        consumedMiles['newPercentage'] = (consumedMiles.new / threshold.miles) * 100;

        // Trips
        consumedTrips['new'] = newTotals.totalTrips;
        consumedTrips['isExceeded'] = (consumedTrips.now + consumedTrips.new) > threshold.trips;
        consumedTrips['newPercentage'] = (consumedTrips.new / threshold.trips) * 100;

        // Amount
        consumedAmount['new'] = newTotals.totalAmount;
        consumedAmount['isExceeded'] = (consumedAmount.now + consumedAmount.new) > threshold.amount;
        consumedAmount['newPercentage'] = (consumedAmount.new / threshold.amount) * 100;
      }

      threshold['consumedMiles'] = consumedMiles;
      threshold['consumedTrips'] = consumedTrips;
      threshold['consumedAmount'] = consumedAmount;
    });
    this.thresholds = thresholds;
    console.log(this.thresholds);
  }

  groupTripsBySpaceType(thresholdsSpaceTypes: any) {
    this.tripsMilesBySaceType = this.trips
      .filter((trip: any) => thresholdsSpaceTypes.includes(trip.spaceType))
      .reduce((acc: any, item: any) => {
        const spaceTypeId = item.spaceType;
        const distance = item.distance || 0; // ensure distance is a number
        const offeredFare = this.fareEstimation
          && this.fareEstimation[item.id]
          && this.fareEstimation[item.id].breakdown ? this.fareEstimation[item.id].breakdown.total : 0

        if (!acc[spaceTypeId]) {
          acc[spaceTypeId] = {
            totalTrips: 0,
            totalMiles: 0,
            totalAmount: 0
          };
        }

        acc[spaceTypeId].totalTrips += 1;
        acc[spaceTypeId].totalMiles += distance;
        acc[spaceTypeId].totalAmount += offeredFare;

        return acc;
      }, {});
  }

  isReserved(trip: any): boolean {
    const expiresAt = trip?.reserved?.expiresAt;

    if (!expiresAt) {
      return false;
    }

    const expiryTime = moment(expiresAt);

    if (!expiryTime.isValid()) {
      return false;
    }

    return moment().isBefore(expiryTime);
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf('day').toISOString(),
    ];
    this.currentPage = 1;
    this.getTrips(this.currentPage);
  }

}
